var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div class=\"key_finder container\">\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <h1 class=\"page-header\">Key Finder</h1>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <div class=\"well\">\n        <form>\n          <div class=\"form-group\">\n            <div class=\"input-group\">\n              <input type=\"text\" name=\"key\" placeholder=\"Key\" autocomplete=\"off\" class=\"form-control\"/>\n              <div class=\"input-group-addon\"><span class=\"fa fa-search\"></span></div>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <button type=\"submit\" class=\"btn btn-warning\">Find</button>\n          </div>\n        </form>\n        <div class=\"result\"></div>\n      </div>\n    </div>\n  </div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}